import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MessagesService } from '../messages/messages.service';
import { Plate } from '../models/plate';
import { PlateStatus, ProcessStep, ProcessUpdateStage } from '../models/process-step';
import { Step } from '../models/step';
import { ErrorHandler } from '../utils/error-handler';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { ExtractionProcessFlows } from '../models/process-flows';
import { Action } from '../models/action';
import { ProcessStepStage } from '../models/process-step-stages';
import { StepAction } from '../models/step-action';
import { MultiPlateUpdate, PlateUpdateInfo } from '../ma-plate-preparation/multiplate-update-dto';
import { Machine } from '../masterdata/models/machine';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { Comment } from '../models/comment';
import { RedoType } from '../models/redo-type-enum';
import { PlateIdTypes } from '../models/plateid-types-enum';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { priorityMap } from '../utils/priority-row';
import { Dropdown } from 'primeng/dropdown';
import { ProcessUpdateDTO, SampleData } from '../models/wb-process-update';
import { Sample } from '../models/sample';
import { SampleRedoDTO } from '../models/sampleRedoDTO';
import { AnalysisType } from '../models/analysis-type';
import { formatDate,DatePipe } from "@angular/common";
import {showLatestComment} from "../utils/latest-comment-util";
import { PlateListDTO } from '../dto/plateListDTO';

const DEFAULT_PROTOCOL_LIST_FOR_EXTRACTION = ["okTOpureHair", "okTOpureEartag", "ExEartagTLR"]
@Component({
  selector: 'app-ma-preparation-extraction',
  templateUrl: './ma-preparation-extraction.component.html',
  styleUrls: ['./ma-preparation-extraction.component.css']
})
export class MaPreparationExtractionComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;

  puid: string;
  selectedLabId: string;
  blocked = false;
  loading: boolean;
  fromDate: Date = new Date();
  isVisible:boolean=false;
  filterOptions: any[];
  selectedStatuses: string[] = [];
  plates: Plate[] = [];

  workFlowList = [];
  workFlowData: WorkFlow[] = [];
  workFlowMap: Map<string, WorkFlow> = new Map();
  selectedProcessFlowList: string[] = [];
  protocolsList = [];
  selectedProtocolList: string[] = [];

  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;

  plateBtn:string;
  plateBtn1:string;
  plateToSearch: string;
  sampleToSearch: string;

  tableSelectedRow :Plate;

  workflowPlateID: string;
  processFlows: ProcessFlow[] = []
  processFlowNameProcessFlowMap: Map<string, ProcessFlow> = new Map();

  workflowSelectionDone: boolean = false;
  detailedWorkflow: boolean = false;
  selectedProcessFlow: string = "";
  processFlowProcessStepMap: Map<string, string[]> = new Map();
  processFlowActionMap: Map<string, string[]> = new Map();
  processFlowInputMap: Map<string, string[]> = new Map();
  statusFilterList = [];
  selectedProcessFlows: ProcessFlow[];

  mapOfStatusSaves = new Map();
  mapOfStatusAndPopUp = new Map();
  mapOfStatusProcessFlowAndRequiredFields = new Map();
  mapOfStatusAndProcessStepCompleteWithStatus = new Map();
  mapOfStatusProcessFlowAndHeaders = new Map();
  mapOfActionRuntime : Map<string, number> = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  mapOfProcessStepAndAction : Map<string, string[]> = new Map();
  @Input() isExtractionSelectedFromPreparationComponent: boolean;
  @Input() tabId: number;
  @Input() scannedPlateID: string = null;

  popUpWithMachineAndChemicals: boolean = false;
  popUpWithMachineAndChemicalsClosable: boolean = true;
  popUpWithMachine: boolean = false;
  popUpWithDifferentMachine: boolean = false;
  multiUpdatePopUp: boolean = false;

  popUpWithMachineAndChemicalsHeader1: string = "";
  popUpWithMachineAndChemicalsHeader2: string = "";
  popUpWithMachineAndChemicalsChemical: string = "";
  popUpWithMachineHeader: string = "";
  popUpWithDifferentMachineHeader: string = "";
  popUpWithDifferentMachineEquipmentPlaceholder: string = "";
  multiUpdatePopUpHeader1: string = "";
  multiUpdatePopUpHeader2: string = "";

  multiShakeRequired: boolean = false;
  multiShakeCheckboxValue: boolean = false;
  multiSpinRequired: boolean = false;
  multiSpinCheckboxValue = false
  multiShakeHeader: string = "";
  multiSpinHeader: string = "";
  multiPlateIdRequired: Array<boolean> = [false,false];
  multiLysisPlateIdRequired: Array<boolean> = [false,false];
  multiDnaPlateIdRequired: Array<boolean> = [false,false];
  multiMagMixPlateIdRequired: Array<boolean> = [false, false];
  multiCompleteProcessStep : boolean;
  multiCompleteProcessStepStatus:string;

  lysisLiquidHandler: string = "";
  extractionLiquidHandler: string = "";
  multiUpdatePlateList = [];
  multiUpdateLysisPlateList = [];
  multiUpdateDnaPlateList = [];
  multiUpdateMagMixPlateList = [];
  multiUpdatePlateListSave : string[]=[];
  multiUpdatePlateInfoList: PlateUpdateInfo[]=[];
  multiPlateStepsMapList: Array<Map<string, Step>> = [];
  enteredPlateId: string;
  enteredLysisPlateId: string;
  enteredDnaPlateId: string;
  enteredMagMixPlateId: string;
  fetchedPlate: Plate;
  multiStage: any;
  multiStepName: any;
  multiActionName: any = null
  multiActionPos: any;
  multiUpdateStatus: string;
  multiUpdateStatusAndProcessFlow: string = "";
  selectedPopUpString="";
  multiUpdateSelectedWorkFlow: string = "";
  multiUpdateButtonStyleClass: string;
  multiPlateStepsMap = new Map();
  multiUpdateStatusLabel: string;
  mapOfStatusAndLabel = new Map;
  multiLiquidHandler: string = "";
  multiChemicalLot: string = "";
  multiChemicalLotBN1: string = "";
  multiChemicalLotTN1: string = "";
  multiChemicalLotTN2: string = "";
  multiChemicalLotAMP: string = "";
  multiChemicalLotBN1List: string[] = []
  multiChemicalLotTN1List: string[] = []
  multiChemicalLotTN2List: string[] = []
  multiChemicalLotAMPList: string[] = []
  lastUpdatedStatus: string;
  lastUpdatedPlates1: any[];
  lastUpdatedPlates2: any[];
  lastUpdatedPlates3: any[];
  chemicalsPlateids: any[];
  multiUpdateProcessStepsMap: Map<string, Step>;
  machinesList: Machine[];
  machinesBarcodeMap: Map<string, Machine> = new Map();
  machineProcessStepStatusMap = new Map();
  multiMachineUpdateInfoDict = new Map();
  multiChemicalLotList: String[] = [];
  fetchedCommentsPlate: Plate;
  selectedPlateID: String = "";
  selectedPlateStatus: String;
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  plateCommentsList: any;
  showCommentDialog: boolean = true;
  nanoDropFail: boolean = false;
  qcNanoDrop: boolean = false;
  qcNanoDropFailPlateSampleMap: Map<string, Sample[]> = new Map<string, Sample[]>();
  extraction: boolean = true;
  lotValuesMap: Array<any> = []
  reRunLysisBool: boolean = true;
  reRunLysisRedoValues:any = {};
  reRunExtractionBool: boolean = true;
  reRunExtractionRedoValues:any = {};
  multiPlateRestoreId:Array<string> = []
  nanoDropPass: boolean = false;
  qcFailRedoList = []
  selectedRedoReason: any = ''
  hairRedoList = [
    {label:"Lysis Redo",value: {"redoLabel":"Lysis Redo","redo":RedoType.LYSIS_REDO,"status":PlateStatus.PLATE_REDO,"stepName":"","sampleType":"Hair"}},
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_STARTED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Hair"}},

  ]
  eartagRedoList = [
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_COMPLETED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Eartag"}},
  ]
  weatherbySampleDataList: Array<SampleData> = []
  samplePlacementPopUp: boolean = false;
  isSRCProcessFlowConfigured: boolean = false;

  @ViewChild('popUpRedoSelector') popUpRedoSelector: Dropdown;
  isProcessUpdateProxied:boolean;
  selectedWorkFlow : WorkFlow;

  showDueDate = false;

  constructor(
      private readonly platePreparationService: MaPlatePreparationService,
      private readonly _messagesService: MessagesService,
      private readonly announcementService:AnnouncedService,
      private readonly masterDataService: MasterDataService,
      private readonly _maStorageService:MaStorageService,
      private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    const isDateRange = JSON.parse(localStorage.getItem('lab')).lab.dateRange;
    this.isExtractionSelectedFromPreparationComponent = false;
    this.checkQCScan();
    this.filterOptions = [
      { label: 'Reception Completed', value: PlateStatus.RECEPTION_COMPLETED },
      { label: 'QC Scan Completed', value: PlateStatus.QCSCAN_COMPLETED},
      { label: 'Lysis Started', value: PlateStatus.LYSIS_STARTED},
      { label: 'Lysis Completed', value: PlateStatus.LYSIS_COMPLETED},
      { label: 'Extraction Started', value: PlateStatus.EXTRACTION_STARTED},
      { label: 'Extraction Completed', value: PlateStatus.EXTRACTION_COMPLETED}
    ];
    this.protocolsList = [
      { label: "OkTOpure Hair", value: "okTOpureHair"},
      { label: "OkTOpure Eartag", value: "okTOpureEartag"},
      { label: "TLR Eartag", value: "ExEartagTLR"},
    ]
    this.getAllActiveWorkFlowList();
    this.getAllProcessFlows();
    if (isDateRange) {
      this.fromDate.setDate(new Date().getDate() - 5);
    } else {
      this.fromDate.setDate(new Date().getDate() - 31);
    }
    this.fetchReceivedPlates(undefined, undefined, this.fromDate);
    this.fetchAllActiveMachines();
    this.selectedPlate = new Plate();
    this.selectedPlateStepsMap = new Map();
    this.multiUpdateProcessStepsMap = new Map();
    this.multiPlateStepsMap = new Map();
    this.multiPlateStepsMapList = new Array();
    this.selectedWorkFlow = JSON.parse(localStorage.getItem("selectedWorkFlow"))
    this.isProcessUpdateProxied = this.selectedWorkFlow.proxyWeatherbyAPI

    //Need to add Nanodrop pass and Nanodrop fail as process steps here conditionally
    this.processFlowProcessStepMap.set(ExtractionProcessFlows.LYSIS_EXT_HAIR, [ProcessStep.LYSIS, ProcessStep.EXTRACTION]);
    this.processFlowProcessStepMap.set(ExtractionProcessFlows.LYSIS_EXT_EARTAG, [ProcessStep.LYSIS, ProcessStep.EXTRACTION]);
    this.processFlowProcessStepMap.set(ExtractionProcessFlows.EXT_EARTAG_TLR, [ProcessStep.EXTRACTION]);



    this.processFlowActionMap.set(ExtractionProcessFlows.LYSIS_EXT_HAIR, [Action.INCUBATE_56C, Action.STOP_INCUBATION_56C]);
    this.processFlowActionMap.set(ExtractionProcessFlows.LYSIS_EXT_EARTAG, [Action.INCUBATE_56C, Action.SPIN, Action.SHAKE_RT, Action.INCUBATE_RT]);
    this.processFlowActionMap.set(ExtractionProcessFlows.EXT_EARTAG_TLR, [Action.INCUBATE_65C, Action.STOP_INCUBATION_65C, Action.INCUBATE_98C, Action.STOP_INCUBATION_98C]);
    this.processFlowInputMap.set(ExtractionProcessFlows.LYSIS_EXT_HAIR, ["LYSIS_PLATE_ID"]);
    this.processFlowInputMap.set(ExtractionProcessFlows.EXT_EARTAG_TLR, ["MA_PLATE_ID"]);

    this.mapOfStatusSaves.set(PlateStatus.LYSIS_STARTED, "startLysis");
    this.mapOfStatusSaves.set(PlateStatus.LYSIS_COMPLETED, "completeLysis");
    this.mapOfStatusSaves.set(PlateStatus.EXTRACTION_STARTED, "startExtraction");
    this.mapOfStatusSaves.set(PlateStatus.EXTRACTION_COMPLETED, "completeExtraction");
    this.mapOfStatusSaves.set(Action.INCUBATE_56C, "actionIncubate56c");
    this.mapOfStatusSaves.set(Action.INCUBATE_56C_1H, "actionIncubate56c1h");
    this.mapOfStatusSaves.set(Action.INCUBATE_56C_2H, "actionIncubate56c2h");
    this.mapOfStatusSaves.set(Action.INCUBATE_56C_ON, "actionIncubate56cOn");
    this.mapOfStatusSaves.set(Action.INCUBATE_56C_R, "actionIncubate56cR");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_56C, "actionStopIncubation56c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_56C_1H, "actionStopIncubation56c1h");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_56C_2H, "actionStopIncubation56c2h");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_56C_ON, "actionStopIncubation56cOn");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_56C_R, "actionStopIncubation56cR");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_65C, "actionStopIncubation65c");
    this.mapOfStatusSaves.set(Action.INCUBATE_65C, "actionIncubate65c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_98C, "actionStopIncubation98c");
    this.mapOfStatusSaves.set(Action.INCUBATE_98C, "actionIncubate98c");
    this.mapOfStatusSaves.set(Action.TRANSFER_LYSIS, "actionTransferLysis");
    this.mapOfStatusSaves.set(Action.PREPARE_OKTOPURE, "actionPrepareOKTOpure");

    this.mapOfStatusAndPopUp.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "popUpWithMachineAndChemicals");
    this.mapOfStatusAndPopUp.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithMachineAndChemicals");
    this.mapOfStatusAndPopUp.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "popUpWithMachine");
    this.mapOfStatusAndPopUp.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "popUpWithMachineAndChemicals");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.STOP_INCUBATION_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "multiUpdatePopUp");
    this.mapOfStatusAndPopUp.set(Action.INCUBATE_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.TRANSFER_LYSIS+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, "popUpWithDifferentMachine");
    this.mapOfStatusAndPopUp.set(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, "popUpWithMachineAndChemicals");

    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID,PlateIdTypes.LYSIS]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.TRANSFER_LYSIS+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID, PlateIdTypes.MAGMIX]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID, PlateIdTypes.DNA]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, [PlateIdTypes.LAST_UPDATED_PLATEID, PlateIdTypes.DNA]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.STOP_INCUBATION_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.INCUBATE_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, [PlateIdTypes.LAST_UPDATED_PLATEID]);
    this.mapOfStatusProcessFlowAndRequiredFields.set(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, [PlateIdTypes.LAST_UPDATED_PLATEID]);

    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["Plates for Lysis:", "Add 320 µL PVP + PK mix.", "PVP + PK"]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Plates for Lysis:", "Add 200 µL PVP + PK mix.", "PVP + PK"]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["Transfer 100µl to lysate plate."]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Plates for Complete Lysis:",
                                                                                                                        "Continue with DNA Extraction?\nNo: Freeze the Lysis Plate\nYes: Continue with Extraction\n",
                                                                                                                        "Shake the plates for 2 min at 1500 rpm."
                                                                                                                      ]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["Load OKTOpure for Extraction","Scan OKTOpure-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Centrifuge the plates for 5 mins at 2000 rpm", "Scan Centrifuge-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["Plates for Extraction:", "Add 200 µL TLR.", "TLR"]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(PlateStatus.EXTRACTION_COMPLETED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["Incubate at 56°C Overnight.", "Scan Oven-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Incubate at 56°C until use!", "Scan Oven-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Incubate at 56°C 60 mins!", "Scan Oven-ID", "Shake the plates for 2 min at 1500 rpm.","Quick Spin the plates."]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Incubate at 56°C 2 hrs!", "Scan Oven-ID", "Shake the plates for 10 sec at 1500 rpm."]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Incubate at 56°C Overnight", "Scan Oven-ID", "Shake the plates for 2 min at 1500 rpm."]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.TRANSFER_LYSIS+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Prepare OKTOpure for Lysis Transfer","Scan OKTOpure-ID","", "Scan MAGMIX Plate"]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Prepare OKTOpure for DNA Extraction", "Scan OKTOpure-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["Prepare OKTOpure for DNA Extraction", "Scan OKTOpure-ID",""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_56C+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_56C_R+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.STOP_INCUBATION_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["", "", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_65C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["Incubate at 65°C for 30 mins!", "Scan Oven-ID", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.INCUBATE_98C+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR, ["Incubate at 98°C for 15 mins!", "Scan Oven-ID", ""]);
    this.mapOfStatusProcessFlowAndHeaders.set(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG, ["Plates for Lysis:", "Add 200 µL PVP + PK mix.", "PVP + PK"]);

    this.mapOfProcessStepAndAction.set(ProcessStep.LYSIS, [Action.INCUBATE_56C, Action.STOP_INCUBATION_56C, Action.INCUBATE_56C_1H, Action.STOP_INCUBATION_56C_1H, Action.INCUBATE_56C_ON, Action.STOP_INCUBATION_56C_ON, Action.INCUBATE_56C_2H, Action.STOP_INCUBATION_56C_2H])
    this.mapOfProcessStepAndAction.set(ProcessStep.EXTRACTION, [Action.INCUBATE_65C, Action.STOP_INCUBATION_65C, Action.INCUBATE_98C, Action.STOP_INCUBATION_98C])

    this.mapOfProcessStepsFlow.set(ProcessStep.LYSIS, [ProcessStep.RECEIVE_PLATE])
    this.mapOfProcessStepsFlow.set(ProcessStep.EXTRACTION, [ProcessStep.LYSIS])

    this.mapOfActionRuntime.set(Action.INCUBATE_56C, 960)
    this.mapOfActionRuntime.set(Action.INCUBATE_56C_R, 0)
    this.mapOfActionRuntime.set(Action.INCUBATE_56C_1H, 60)
    this.mapOfActionRuntime.set(Action.INCUBATE_56C_2H, 120)
    this.mapOfActionRuntime.set(Action.INCUBATE_56C_ON, 960)
    this.mapOfActionRuntime.set(Action.INCUBATE_65C, 30)
    this.mapOfActionRuntime.set(Action.INCUBATE_98C, 15)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_56C, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_56C_1H, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_56C_2H, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_56C_ON, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_56C_R, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_65C, 0)
    this.mapOfActionRuntime.set(Action.STOP_INCUBATION_98C, 0)
    this.mapOfActionRuntime.set(Action.TRANSFER_LYSIS, 0)
    this.mapOfActionRuntime.set(Action.PREPARE_OKTOPURE, 0)
    this.mapOfActionRuntime.set(Action.ADD_CHEMICAL_MIX, 0)
    this.mapOfActionRuntime.set(Action.SPIN, 0)

    this.mapOfStatusAndLabel.set(PlateStatus.LYSIS_STARTED, "Start Lysis")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_56C, "Incubate 56°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_56C_R, "Incubate 56°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_56C_1H, "Incubate 56°C 1h")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_56C_2H, "Incubate 56°C 2h")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_56C_ON, "Incubate 56°C ON")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_56C, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_56C_1H, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_56C_2H, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_56C_ON, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_56C_R, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_65C, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_98C, "Complete Extraction")
    this.mapOfStatusAndLabel.set(PlateStatus.LYSIS_COMPLETED, "Complete Lysis")
    this.mapOfStatusAndLabel.set(PlateStatus.EXTRACTION_STARTED, "Start Extraction")
    this.mapOfStatusAndLabel.set(PlateStatus.EXTRACTION_COMPLETED, "Complete Extraction")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_65C, "Incubate 65°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_98C, "Incubate 98°C")
    this.mapOfStatusAndLabel.set(Action.TRANSFER_LYSIS, "Transfer Lysis")
    this.mapOfStatusAndLabel.set(Action.PREPARE_OKTOPURE, "Prepare OKTOpure")
    this.mapOfStatusAndLabel.set(Action.ADD_CHEMICAL_MIX, "Add Chemical Mix")

    this.mapOfStatusAndProcessStepCompleteWithStatus.set(Action.STOP_INCUBATION_98C,{
      "processStepComplete":true,
      "processStepStatus":PlateStatus.EXTRACTION_COMPLETED
    })

    this.machineProcessStepStatusMap.set(PlateStatus.LYSIS_STARTED, PlateStatus.LYSIS_STARTED)
    this.machineProcessStepStatusMap.set(Action.INCUBATE_56C, Action.INCUBATE_56C)
    this.machineProcessStepStatusMap.set(PlateStatus.LYSIS_COMPLETED, PlateStatus.LYSIS_COMPLETED)
    this.machineProcessStepStatusMap.set(PlateStatus.EXTRACTION_STARTED, PlateStatus.EXTRACTION_STARTED)
    if(this.scannedPlateID && this.tabId == 1) {
      this.searchForPlateAction(this.scannedPlateID);
      this.scannedPlateID = null;
    }
  }


  ngOnChanges() {
    this.ngOnInit();
  }

  switchProcessFlow(processFlow: string){
    if(processFlow==ExtractionProcessFlows.LYSIS_EXT_HAIR){
      this.mapOfProcessStepsFlow.set(ProcessStep.LYSIS, [ProcessStep.RECEIVE_PLATE])
      this.mapOfProcessStepsFlow.set(ProcessStep.EXTRACTION, [ProcessStep.LYSIS])
      if(this.qcNanoDrop){
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_PASS, [ProcessStep.EXTRACTION])
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_FAIL, [ProcessStep.EXTRACTION])
      }

      this.mapOfProcessStepAndAction.set(ProcessStep.LYSIS, [Action.INCUBATE_56C, Action.STOP_INCUBATION_56C])
      this.mapOfProcessStepAndAction.set(ProcessStep.EXTRACTION, [Action.PREPARE_OKTOPURE])

    }else if(processFlow==ExtractionProcessFlows.LYSIS_EXT_EARTAG){
      this.mapOfProcessStepsFlow.set(ProcessStep.LYSIS, [ProcessStep.RECEIVE_PLATE])
      this.mapOfProcessStepsFlow.set(ProcessStep.EXTRACTION, [ProcessStep.LYSIS])
      if(this.qcNanoDrop){
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_PASS, [ProcessStep.EXTRACTION])
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_FAIL, [ProcessStep.EXTRACTION])
      }
      this.mapOfProcessStepAndAction.set(ProcessStep.LYSIS, [Action.INCUBATE_56C_1H, Action.STOP_INCUBATION_56C_1H, Action.INCUBATE_56C_ON, Action.STOP_INCUBATION_56C_ON, Action.INCUBATE_56C_2H, Action.STOP_INCUBATION_56C_2H])
      this.mapOfProcessStepAndAction.set(ProcessStep.EXTRACTION, [Action.INCUBATE_56C_R, Action.STOP_INCUBATION_56C_R, Action.TRANSFER_LYSIS, Action.PREPARE_OKTOPURE])

    }else if(processFlow==ExtractionProcessFlows.EXT_EARTAG_TLR){
      this.mapOfProcessStepsFlow.set(ProcessStep.LYSIS, [ProcessStep.RECEIVE_PLATE])
      this.mapOfProcessStepsFlow.set(ProcessStep.EXTRACTION, [ProcessStep.RECEIVE_PLATE])
      if(this.qcNanoDrop){
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_PASS, [ProcessStep.EXTRACTION])
        this.mapOfProcessStepsFlow.set(ProcessStep.NANODROP_FAIL, [ProcessStep.EXTRACTION])
      }

      this.mapOfProcessStepAndAction.set(ProcessStep.LYSIS, [Action.INCUBATE_56C, Action.SPIN ,Action.SHAKE_RT, Action.INCUBATE_RT])
      this.mapOfProcessStepAndAction.set(ProcessStep.EXTRACTION, [Action.INCUBATE_65C, Action.STOP_INCUBATION_65C ,Action.INCUBATE_98C, Action.STOP_INCUBATION_98C])

    }else{
      this._messagesService.addWarningMessage({
        severity: 'warn', detail: 'Process flow '+processFlow+' is not known',
        summary: 'Unknown process flow'
      })
    }
  }

  firstIncubate(){
    this.multiSpinRequired = true
    this.multiSpinCheckboxValue = false
  }

  savePlateStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number) {
    if(!this.detailedWorkflow){
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
      return;
    }
    else {
      if(status+"_"+this.selectedProcessFlow == Action.INCUBATE_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
        if(!this.checkAddLotForEarTagLysisProcessStep()){
          return this.savePlateStatus(Action.ADD_CHEMICAL_MIX,2,ProcessStep.LYSIS, Action.ADD_CHEMICAL_MIX, 0);
        }
      }else if(status+"_"+this.selectedProcessFlow == Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
        this.popUpWithMachineAndChemicalsClosable = false;
      }
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;
      if(stage==ProcessStepStage.start){
        this.multiUpdateButtonStyleClass = "startButton"
      }else if(stage==ProcessStepStage.end){
        this.multiUpdateButtonStyleClass = "endButton"
      }else{
        this.multiUpdateButtonStyleClass = "VioletButtons"
      }
      this.multiUpdateStatusAndProcessFlow = status+"_"+this.selectedProcessFlow
      if(this.multiUpdateStatusAndProcessFlow == PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
        this.multiUpdateStatusLabel = "Centrifuge"
      }
      this.selectedPopUpString = this.mapOfStatusAndPopUp.get(this.multiUpdateStatusAndProcessFlow)
      this[this.selectedPopUpString] = true
      this.setRequiredFields(this.multiUpdateStatusAndProcessFlow, this.selectedPopUpString)
    }
  }

  setRequiredFields(selectedStatusAndProcessFlow: string, popUpString: string){
    let requiredFields: Array<string> = this.mapOfStatusProcessFlowAndRequiredFields.get(selectedStatusAndProcessFlow);
    requiredFields.forEach((field,index) => {
      if(field==PlateIdTypes.LAST_UPDATED_PLATEID){
        this.multiPlateIdRequired[0] = true;
        if(index == 0){
          this.multiPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(popUpString+"-popup-plateid")
          },100);
        }
      }else if(field==PlateIdTypes.LYSIS){
        this.multiLysisPlateIdRequired[0] = true;
        if(index == 0){
          this.multiLysisPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(popUpString+"-popup-lysis-plateid");
          }, 100)
        }
      }else if(field==PlateIdTypes.DNA){
        this.multiDnaPlateIdRequired[0] = true;
        if(index == 0){
          this.multiDnaPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(popUpString+"-popup-dna-plateid");
          }, 100)
        }
      }
      else if(field == PlateIdTypes.MAGMIX){
        this.multiMagMixPlateIdRequired[0] = true
        if(index == 0){
          this.multiMagMixPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(popUpString+"-popup-magmix-plateid");
          }, 100)
        }
      }
    })

    if(
      [
        Action.INCUBATE_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG,
        Action.INCUBATE_56C_1H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG,
        Action.INCUBATE_56C_2H+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG,
        PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG,
      ].includes(this.multiUpdateStatusAndProcessFlow)
    ){
      this.multiSpinRequired = false;
      this.multiSpinCheckboxValue = true;
      this.multiShakeRequired = true;
      this.multiShakeCheckboxValue = false;
    }
    else{
      this.multiSpinRequired = false
      this.multiSpinCheckboxValue = true
      this.multiShakeRequired = false;
      this.multiShakeCheckboxValue = true;
    }

    if(this.mapOfStatusAndProcessStepCompleteWithStatus.has(this.multiUpdateStatus)){
      let stepCompleteValues = this.mapOfStatusAndProcessStepCompleteWithStatus.get(this.multiUpdateStatus)
      this.multiCompleteProcessStep = stepCompleteValues["processStepComplete"]
      this.multiCompleteProcessStepStatus = stepCompleteValues["processStepStatus"]
    }

    let popUpValues = this.mapOfStatusProcessFlowAndHeaders.get(this.multiUpdateStatusAndProcessFlow)
    if(popUpString == "popUpWithMachineAndChemicals"){
      this.popUpWithMachineAndChemicalsHeader1 = popUpValues[0]
      this.popUpWithMachineAndChemicalsHeader2 = popUpValues[1]
      this.popUpWithMachineAndChemicalsChemical = popUpValues[2]
      if(this.multiUpdateStatusAndProcessFlow == Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
        this.multiUpdateStatusLabel = "Add " + popUpValues[2] + " Mix"
      }
    }
    else if(popUpString == "popUpWithDifferentMachine"){
      this.popUpWithDifferentMachineHeader = popUpValues[0];
      this.popUpWithDifferentMachineEquipmentPlaceholder = popUpValues[1];
      this.multiShakeHeader = popUpValues[2];
      this.multiSpinHeader = popUpValues[3]
      setTimeout(() => {
        this.findAndHighlightElement(popUpString+"-popup-machineid");
      }, 100)
    }
    else if(popUpString == "popUpWithMachine"){
      this.popUpWithMachineHeader = popUpValues[0];
      setTimeout(() => {
        this.findAndHighlightElement(popUpString+"-popup-machineid")
      }, 100);
    }else if(popUpString == "multiUpdatePopUp"){
      this.multiUpdatePopUpHeader1 = popUpValues[0];
      this.multiUpdatePopUpHeader2 = popUpValues[1];
      this.multiShakeHeader = popUpValues[2];
      this.multiSpinHeader = popUpValues[3]
      setTimeout(() => {
        this.findAndHighlightElement(popUpString+"-popup-machineid")
      }, 100);
    }
  }

  deleteLotValue(index){
    this.multiChemicalLotList.splice(index,1);
  }


  checkAddLotForEarTagLysisProcessStep(){
    let lysisProcessStep = this.selectedPlateStepsMap.get(ProcessStep.LYSIS);
    return (lysisProcessStep.actionMap.has(Action.ADD_CHEMICAL_MIX))
  }

  startLysis(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.start, "",this.lysisLiquidHandler)){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(status);
  }

  completeLysis(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.end, "","")){
      return;
    }
    if(this.selectedProcessFlow == ExtractionProcessFlows.LYSIS_EXT_HAIR){
      this.selectedPlate.addNewPlateMeta = true
    }
    this.selectedPlate.status = status;
    if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
      this.multiPlateRestoreId.push(this.selectedPlate.lastUpdatedPlateID)
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.lysisPlateID === null ? this.selectedPlate.lastUpdatedPlateID : this.selectedPlate.lysisPlateID;
    this.updatePlate(status);
  }

  startExtraction(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.start, "",this.extractionLiquidHandler)){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(status);
  }

  completeExtraction(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.end, "","")){
      return;
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.dnaPlateID === "" ?  this.selectedPlate.lysisPlateID === "" ? this.selectedPlate.lastUpdatedPlateID : this.selectedPlate.lysisPlateID : this.selectedPlate.dnaPlateID
    this.selectedPlate.dnaPlateID = this.selectedPlate.lastUpdatedPlateID
    this.prepareSampleDataList<Sample>(this.selectedPlate.samples,(sample) => {
      let sampleData : SampleData = {
        sampleId : sample._id,
        description : "",
        stageGate : 3,
        status:ProcessUpdateStage.STAGE_GATE
      }
      return sampleData
    })
    if(this.qcNanoDrop){
      this.selectedPlate.status = PlateStatus.EXTRACTION_QC
      this.updatePlate(PlateStatus.EXTRACTION_QC)
    }
    else{
      this.selectedPlate.status = status;
      this.updatePlate(status);
    }
  }

  actionIncubate56c(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate56c1h(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate56c2h(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate56cOn(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate56cR(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation56c(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation56c1h(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation56c2h(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation56cOn(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation56cR(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation65c(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation98c(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionShakeRT(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubateRT(status: string){
    if(!this.updateProcessStep(ProcessStep.LYSIS, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate65c(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate98c(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionTransferLysis(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.lysisPlateID === "" ? this.selectedPlate.lastUpdatedPlateID : this.selectedPlate.lysisPlateID;
    this.updatePlate();
  }

  actionPrepareOKTOpure(status: string){
    if(!this.updateProcessStep(ProcessStep.EXTRACTION, ProcessStepStage.action, status)){
      return;
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.dnaPlateID === "" ? this.selectedPlate.lastUpdatedPlateID : this.selectedPlate.dnaPlateID;
    this.updatePlate();
  }

  updatePlate(status: string = "") {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    if(this.multiPlateRestoreId.length > 0){
      this.selectedPlate.version += 1
      this.restorePlatesFromStorage(this.multiPlateRestoreId, () => {
        this.callBackUpdatePlate(status)
      })
      return
    }
    if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
      this.selectedPlate.version += 1
      this.restorePlatesFromStorage([this.selectedPlate.lastUpdatedPlateID] , () => {
        this.callBackUpdatePlate(status)
      })
      return
    }
    this.callBackUpdatePlate(status)
  }
  callBackUpdatePlate(status: string = ""){
    this.blocked = true
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.nanoDropFail = false
        if([PlateStatus.EXTRACTION_COMPLETED,PlateStatus.EXTRACTION_QC].includes(status) && this.weatherbySampleDataList.length !== 0){
          this.performProcessUpdateForWeatherby()
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID+' has been updated successfully with requested status'
        })
        this.searchForPlateAction(this.selectedPlate.plateID);
        status = "";
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean{
    if(this.selectedPlateStepsMap.has(step)){
      var existingStep = this.selectedPlate.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
        }
      }
    }else{
      this.selectedPlate.processSteps = (!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null) ? [] : this.selectedPlate.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.endPUID = "";
        newStep.endTimeStamp = null;

        newStep.chemicals=[];

      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      //temp: harcoding action step as [] to avoid server 500
      newStep.action = [];
      newStep.chemicals = [];
      newStep.liquidHandler = newStep.liquidHandler ? newStep.liquidHandler : "";
      this.selectedPlate.processSteps.push(newStep)
    }
    return true;
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string) {
    var stepsMap = this.selectedPlateStepsMap;
    if (stepsMap.get(stepName).actionMap && stepsMap.get(stepName).actionMap.get(actionName) != undefined && stepsMap.get(stepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
      let actionRunTime: number = stepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
      if(actionName == Action.STOP_INCUBATION_56C){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_56C).getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_56C_1H){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_56C_1H).getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_56C_2H){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_56C_2H).getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_56C_ON){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_56C_ON).getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_65C){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_65C).getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_98C){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_98C).getTime())/1000)
      }
      if(actionName == Action.INCUBATE_56C_R){
        return this.calculatingTimes((new Date().getTime()  -actionStartTime.getTime())/1000)
      }
      if(actionName == Action.STOP_INCUBATION_56C_R){
        return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_56C_R).getTime())/1000)
      }
      return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
    } else {
      let actionRunTime = this.mapOfActionRuntime.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  getProcessStepActionPuid(stepName: string, actionName: string){
    return this.selectedPlateStepsMap.get(stepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string){
    var stepsMap = this.selectedPlateStepsMap;
    return this.convertUtcToLocal(stepsMap.get(stepName).actionMap.get(actionName).actionStartTime);
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  isValidProcessStep(stepName: string): boolean {
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return (stepsMap.get(tempStepName) != undefined && stepsMap.get(tempStepName) != null);
  }

  isValidProcessStepAction(stepName: string, actionName: string){
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return (stepsMap.get(tempStepName) != undefined && stepsMap.get(tempStepName) != null);
  }

  isValidProcessStepActionPerformed(stepName: string, actionName: string){
    return ( this.selectedPlateStepsMap.get(stepName) && this.selectedPlateStepsMap.get(stepName).actionMap.get(actionName));
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return this.convertUtcToLocal(stepsMap.get(tempStepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return this.convertUtcToLocal(stepsMap.get(tempStepName).endTimeStamp);
  }

  getProcessStepStartPuid(stepName: string): string {
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return stepsMap.get(tempStepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    var stepsMap = this.selectedPlateStepsMap;
    var tempStepName = stepName
    return stepsMap.get(tempStepName).endPUID;
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean{
    if((!this.selectedPlateStepsMap || this.selectedPlateStepsMap==null || this.selectedPlateStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName,this.selectedPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName,this.selectedPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos,this.selectedPlateStepsMap);
      default:
        return true;
    }
  }

  disableProcessStepStart(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    let dependentSteps: string[] = this.mapOfProcessStepsFlow.get(stepName);
    let disable: boolean = true;
    for(let step of dependentSteps){
      if(step==ProcessStep.RECEIVE_PLATE){
        disable = !selectedPlateStepsMap.has(step) || this.isEmptyString(selectedPlateStepsMap.get(step).startPUID) || this.isEmptyDate(selectedPlateStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedPlateStepsMap.has(stepName)){
      disable = true;
    }

    return disable ? disable : this.checkProcessStepStartForLysisAndExtraction(stepName);
  }

  checkProcessStepStartForLysisAndExtraction(stepName:string){
    let processFlow = this.selectedProcessFlows.find(process => process.processFlowName === this.selectedPlate.processFlowName)
    if(this.selectedProcessFlows && processFlow && processFlow.qcScan){
      if(stepName === ProcessStep.LYSIS){
        let isValidForLysis = [PlateStatus.QCSCAN_COMPLETED,PlateStatus.LYSIS_STARTED].includes(this.selectedPlate.status)
        return !isValidForLysis
      }
      else if(stepName === ProcessStep.EXTRACTION && this.selectedProcessFlow === ExtractionProcessFlows.EXT_EARTAG_TLR){
        let isValidForExtraction = [PlateStatus.QCSCAN_COMPLETED,PlateStatus.EXTRACTION_STARTED].includes(this.selectedPlate.status)
        return !isValidForExtraction
      }
    }
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedPlateStepsMap:Map<string, Step>): boolean{
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(actionPos==0){
      disable = currentProcessStep.actionMap.has(actionName);
    }else{
      if(!currentProcessStep.actionMap.has(actionName) && currentProcessStep.actionMap.has(processStepActions[actionPos-1])){
        disable = false;
      }
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(processStepActions && processStepActions.length>0){
      let previousAction = processStepActions[processStepActions.length-1];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else{
      disable = false;
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true;
    }
    return disable;
  }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  onApplyFilter(){
    this.getProcessFlowListFromProtocolList();
    let queryStatusList = this.selectedStatuses.join(',');
    let querysampleTypeList = this.selectedProcessFlowList.join(',');
    this.fetchReceivedPlates(queryStatusList, querysampleTypeList, this.fromDate);
  }

  resetAllFilter(){
    this.selectedStatuses = [];
    this.selectedProtocolList = []
    this.selectedProcessFlowList = [];
    this.fromDate = undefined;
    this.getProcessFlowListFromProtocolList();
    this.fetchReceivedPlates();
  }

  getProcessFlowListFromProtocolList(){
    this.selectedProcessFlowList = [];
    let queryProtocolList = this.selectedProtocolList.length==0? DEFAULT_PROTOCOL_LIST_FOR_EXTRACTION : this.selectedProtocolList
    this.processFlows.forEach( processFlow => {
      for(let i=0; i<queryProtocolList.length; i++){
        if(processFlow[queryProtocolList[i]]){
          this.selectedProcessFlowList.push(processFlow.processFlowName)
          break;
        }
      }
    })
  }

  getAllActiveWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe({next:results => {
      if (results && results.data) {
        this.workFlowData = results.data;
        this.workFlowList = [];
        this.workFlowData.forEach(e => {
          this.workFlowList.push({ label: e.workFlowName, value: e.workFlowName });
          this.workFlowMap.set(e.workFlowName, e);
        });
        this.blocked = false;
      }
    },error:(error: any) => {
        this.blocked = false;
        this.showError(error);
    }});
  }

  getAllProcessFlows() {
    this.processFlowNameProcessFlowMap.clear();
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe({next:results => {
      this.blocked = false;
      if(results && results.data){
        this.processFlows = results.data;
        this.processFlows.forEach(p => {
          this.processFlowNameProcessFlowMap.set(p.processFlowName, p);
        })
      }
    },error: error => {
      this.blocked = false;
      this.showError(error);
    }})
  }

  searchForPlate() {
    this.plateBtn1="enabeledd";
    if(!this.plateToSearch || this.plateToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.searchForPlateAction(this.plateToSearch);
    this.plateToSearch="";
  }

  searchForPlateWithWorkflow(){
    if(!this.workflowPlateID || this.workflowPlateID==='' || this.workflowPlateID.trim() == ''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.blocked = true;
    this.searchForPlateAction(this.workflowPlateID);
  }

  findProcessFlow(sampleType, processFlowName, plateID){
    if(!sampleType || !this.processFlowNameProcessFlowMap.has(processFlowName)){
      this._messagesService.addErrorMessage({
        severity: 'error', detail: plateID+' does not get an extraction',
        summary: 'No extraction configured'
      });
      return;
    }

    var processFlowConfig : ProcessFlow = this.processFlowNameProcessFlowMap.get(processFlowName)
    if(!processFlowConfig){
      this._messagesService.addErrorMessage({
        severity: 'error', detail: plateID+' does not get an extraction',
        summary: 'No extraction configured'
      })
      return;
    }
    this.qcNanoDrop = processFlowConfig.qcNanodrop;
    this.isSRCProcessFlowConfigured = processFlowConfig.automaticReception;
    this.selectedProcessFlow = this.selectPlateFlowFromProcessFlow(processFlowConfig)
    if(this.qcNanoDrop){
      this.processFlowProcessStepMap.get(this.selectedProcessFlow).push(ProcessStep.NANODROP_PASS, ProcessStep.NANODROP_FAIL)
    }
    if(this.selectedProcessFlow){
      this.workflowSelectionDone = true
    }

    if(processFlowConfig.detailedWorkflow){
      this.detailedWorkflow = true
    }

    this.switchProcessFlow(this.selectedProcessFlow);
  }

  selectPlateFlowFromProcessFlow(processFlowConfig){
    if(processFlowConfig.okTOpureHair){
      this.reRunLysisBool = true;
      this.reRunLysisRedoValues = {"redo":RedoType.LYSIS_REDO,"status":PlateStatus.PLATE_REDO,"stepName":"","sampleType":"Hair"};
      this.reRunExtractionBool = true;
      this.reRunExtractionRedoValues = {"redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_STARTED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Hair"};
      return ExtractionProcessFlows.LYSIS_EXT_HAIR;
    }else if(processFlowConfig.okTOpureEartag){
      this.reRunLysisBool = false;
      this.reRunLysisRedoValues = {};
      this.reRunExtractionBool = true;
      this.reRunExtractionRedoValues = {"redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_COMPLETED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Eartag"};
      return ExtractionProcessFlows.LYSIS_EXT_EARTAG;
    }else if(processFlowConfig.ExEartagTLR){
      this.reRunLysisBool = false;
      this.reRunLysisRedoValues = {};
      this.reRunExtractionBool = false;
      this.reRunExtractionRedoValues = {};
      return ExtractionProcessFlows.EXT_EARTAG_TLR;
    }else{
      this._messagesService.addErrorMessage({
        severity: 'error', detail: this.selectedPlate.plateID+' does not get an extraction',
        summary: 'No extraction configured'
      })
      return;
    }
  }

  qcNanoDropPass(){
    // Code to continue the process
    let multiPlateUpdate : MultiPlateUpdate = new MultiPlateUpdate();
    if(!this.detailedWorkflow){
      let plateUpdateInfo = new PlateUpdateInfo()
      plateUpdateInfo.plateID = this.selectedPlate.plateID
      plateUpdateInfo.lysisPlateID = this.selectedPlate.lysisPlateID
      plateUpdateInfo.dnaPlateID = this.selectedPlate.dnaPlateID
      multiPlateUpdate.plateids = [this.selectedPlate.plateID];
      multiPlateUpdate.plateUpdateInfoList = [plateUpdateInfo];
    }
    else{
      multiPlateUpdate.plateids = this.multiUpdatePlateListSave;
      multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList;
    }
    multiPlateUpdate.action = this.multiActionName;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.actionRunTime = this.mapOfActionRuntime.get(this.multiActionName);
    multiPlateUpdate.machineUpdateInfoDict = this.multiMachineUpdateInfoDict
    multiPlateUpdate.processFlow = this.selectedProcessFlow;
    multiPlateUpdate.qcNanodrop = this.qcNanoDrop
    multiPlateUpdate.step = ProcessStep.NANODROP_PASS
    multiPlateUpdate.status = PlateStatus.EXTRACTION_COMPLETED

    this.platePreparationService.updateStartProcessForMultiplePlates(multiPlateUpdate).subscribe({
      next:(result) =>{
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiPlateUpdate.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.detailedWorkflow = true;
        if(this.multiUpdateStatusAndProcessFlow == PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_56C, 2, ProcessStep.LYSIS, Action.INCUBATE_56C, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_65C, 2, ProcessStep.EXTRACTION, Action.INCUBATE_65C, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
          setTimeout(() => {
            this.multiSpinRequired = true
            this.multiSpinCheckboxValue = false
            this.savePlateStatus(Action.INCUBATE_56C_1H, 2, ProcessStep.LYSIS, Action.INCUBATE_56C_1H, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_56C_R, 2, ProcessStep.EXTRACTION, Action.INCUBATE_56C_R, 0)
          }, 1000);
        }
        if([PlateStatus.START_PREPCR, PlateStatus.RECOMBINING_STARTED, PlateStatus.PRECIPITATION_STARTED, PlateStatus.RESUSPENDING_STARTED].includes(multiPlateUpdate.status))
          this.updateMachine(multiPlateUpdate.liquidHandler, multiPlateUpdate.status, this.multiUpdateSelectedWorkFlow);
      },
      error:(error) =>{
        if(this.multiStepName==ProcessStep.SAFE_STOPPING)
          this.multiUpdateStatus = PlateStatus.STORED;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  reRun(){
    let multiUpdateDto = this.getReRunMultiUpdateDto();
    const sampleRedoDetails = new SampleRedoDTO();
    sampleRedoDetails.sampleIdList = multiUpdateDto.plateids
      .map((plateId) => this.qcNanoDropFailPlateSampleMap.get(plateId))
      .map((samples) =>
        samples.map((sample) => ({
          sampleID: sample._id,
          type: AnalysisType.INTERNAL_RERUN,
        }))
      )
      .reduce((samples, currentSamples) => samples.concat(currentSamples), []);
    sampleRedoDetails.analysisType = true;
    sampleRedoDetails.reRunCount = false;
    this.blocked = true
    this.platePreparationService.updateQCCheckForMultiplePlates(multiUpdateDto, this.selectedLabId).subscribe({
      next:(result) => {
        this.announcementService.updateRedoSample(this.selectedLabId, sampleRedoDetails).subscribe(
          _result=>{
            this._messagesService.addSuccessMessage({
              severity:'success',summary:"Success!", detail: result
            })
          }
        )
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        if(PlateStatus.PLATE_REDO ==  multiUpdateDto.status){
          this.selectedPlateStepsMap.clear();
        }
        this.updateLastUpdatedPlates();
        this.closeMultiUpdatePopup();
        this.nanoDropFail = false;
      },
      error:(error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  getReRunMultiUpdateDto(){
    let multiPlateUpdate : MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.action = Action.QC_CHECK;
    multiPlateUpdate.plateids = this.multiUpdatePlateListSave
    multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList
    multiPlateUpdate.step = ProcessStep.NANODROP_FAIL;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.actionRunTime = 0;
    multiPlateUpdate.processFlow = this.selectedProcessFlow;
    return multiPlateUpdate;
  }

  toggleNanodropFail(){
    if(this.reRunExtractionBool || this.reRunLysisBool){
      this.nanoDropFail = !this.nanoDropFail
      this.enteredPlateId = ''
      this.multiUpdatePlateInfoList = []
      this.multiUpdatePlateListSave = []
    }
    else{
      this._messagesService.addWarningMessage({
        severity: "warn", summary:"QC Nanodrop Fail not applicable",
        detail:"This plates does not get QC Nanodrop Fail as it is a TLR plate."
      })
    }
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,this.selectedPlate.plateID).subscribe({
      next:(result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
        this.showCommentDialog = true;
      },
      error:(error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })

  }

  workflowSelection(plateID: string){
    this.blocked = true;
    this.platePreparationService.fetchPlate(this.workflowPlateID,this.selectedLabId).subscribe({
      next:(result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.findProcessFlow(result.sampleType, result.processFlowName, result.plateID);
        this.prepareProcessStepsMap();
      },error: (error) => {
        this.blocked = false;
        this.workflowPlateID="";
        this.workflowSelectionDone = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate workflow',
          detail: error.error
        })
      }
    })
  }

  fetchStorageNameForPlate(plateId:string){
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,plateId).subscribe({
      next:storage => {
        this.blocked = false
        this.selectedPlate.storage = storage.storageName
      },
      error:error => {
        this.blocked = false
        console.error(error)
      }
    })
  }

  restorePlatesFromStorage(plates:string[] = [], callBack : () => void){
    let body = {
      "labid":this.selectedLabId,
      "plateids":plates
    }
    this.blocked = true
    this._maStorageService.removeMultiplePlatesFromStorage(body).subscribe({
      next:_r => {
        let data = {
          'plateIDs':plates
        }
        this._maStorageService.restorePlatesFromStorage(this.selectedLabId,data).subscribe({
          next:_r => {
            this.blocked = false
            this.multiPlateRestoreId = []
            callBack()
          },
          error:error => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong while restoration',
              detail:error
            })
            callBack()
          }
        })
      },
      error:error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while restoration',
          detail:error
        })
        callBack()
      }
    })
  }

  searchForPlateAction(plateID: string){
    this.isVisible=false;
    this.multiChemicalLotList = []
    this.multiChemicalLot = ""
    this.multiChemicalLotBN1 = "";
    this.multiChemicalLotTN1 = "";
    this.multiChemicalLotTN2 = "";
    this.multiChemicalLotAMP = "";
    this.detailedWorkflow = false
    this.blocked = true;
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next:(result) => {
        this.blocked = false;
        this.qcNanoDrop = false
        this.workflowPlateID="";
        this.selectedPlate = result;
        if(this.selectedPlate.storagePlate){
          this.fetchStorageNameForPlate(this.selectedPlate.lastUpdatedPlateID)
        }
        this.showComments()
        this.findProcessFlow(result.sampleType, result.processFlowName, result.plateID);
        if(PlateStatus.PLATE_REDO == this.selectedPlate.status){
          this._messagesService.addWarningMessage({
            severity:'warn', summary:"Cannot process the current plate!!"
          })
          return;
        }
        this.prepareProcessStepsMap();
      },error: (error) => {
        this.blocked = false;
        this.workflowPlateID="";
        this.workflowSelectionDone = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        })
      }
    })
  }

  searchForSample() {
    this.isVisible=false;
    this.plateBtn1="enabeledd";
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({next :(result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId).subscribe({
        next:(result)=>{
          this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedPlate = result;
          this.findProcessFlow(result.sampleType, result.processFlowName, result.plateID);
          if(PlateStatus.PLATE_REDO == this.selectedPlate.status){
            this._messagesService.addWarningMessage({
              severity:'warn', summary:"Cannot process the current plate!!"
            })
            return;
          }
          this.prepareProcessStepsMap();
          this.sampleToSearch="";
        },error: (error) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch plate info',
            detail: error.error.error
          })
        }
    })
    }, error: (error: any) => {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Failed to fetch plate info',
        detail: error.error.error
      })
    }})
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();
    if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
      return;
    this.selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.selectedPlateStepsMap.set(step.step, step);
      }
    )

    this.lysisLiquidHandler = this.getProcessStepLiquidHandler(ProcessStep.LYSIS);
    this.extractionLiquidHandler = this.getProcessStepLiquidHandler(ProcessStep.EXTRACTION);
  }

  fetchPlate(event) {
    this.plateBtn='enabeled';
    this.searchForPlateAction(event.data.plateID);
  }

  checkQCScan(){
    this.selectedProcessFlows = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    this.statusFilterList = [PlateStatus.RECEPTION_COMPLETED, PlateStatus.LYSIS_STARTED, PlateStatus.LYSIS_COMPLETED, PlateStatus.EXTRACTION_COMPLETED, PlateStatus.EXTRACTION_QC,PlateStatus.EXTRACTION_STARTED];
    let isQCScan = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      if(this.selectedProcessFlows[i].qcScan){
        this.statusFilterList.push(PlateStatus.QCSCAN_COMPLETED);
        isQCScan = true;
        break
      }
    }
    if(!isQCScan){
      this.statusFilterList.push(PlateStatus.RECEIVED, PlateStatus.RECEPTION_COMPLETED)
    }
    if(this.isExtractionSelectedFromPreparationComponent){
      this.onApplyFilter();
      this.isExtractionSelectedFromPreparationComponent = false;
    }
    return true
  }

  preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US')
    }
    return plateListDTO;
  }

  fetchReceivedPlates(status?: string, processFlowName?: string, fromDate?: Date) {
    this.loading = true;
    if(status === '' || status == undefined){
      status = this.statusFilterList.join(',');
    }
    if(processFlowName === '' || processFlowName == undefined){
      processFlowName = this.selectedProcessFlowList.length!=0? this.selectedProcessFlowList.join(",") : undefined;
    }
    if(fromDate === undefined){
      fromDate = undefined;
    }
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE", status, processFlowName, fromDate)).subscribe({
      next : (result) => {
        this.plates = result;
        this.loading = false;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error: any) => {
        this.loading = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }})
  }

  getPlateValue() {
    if (this.selectedPlate) {
      return  this.selectedPlate.lastUpdatedPlateID;
    }
  }

  fetchAllActiveMachines(){
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = results.data;
        this.machinesList.forEach(machine => {
          this.machinesBarcodeMap.set(machine.barcode, machine);
        })
      }
    )
  }

  removePlateSelection(){
    this.selectedPlateStepsMap.clear();
    this.workflowSelectionDone = false;
    this.detailedWorkflow = false;
    this.selectedPlate = new Plate();
    this.selectedPlateID = ""
    this.fetchedCommentsPlate = null;

    this.selectedPlateStatus = "";
    this.plateCommentsList = [];
    this.beadChipCommentsDisplayMap.clear()
    this.beadChipCommentsMap.clear()
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  disableQCPass(){
    if(this.qcNanoDrop){
      this.selectedPlate.processSteps.forEach(steps => {
        if(steps.step == ProcessStep.NANODROP_PASS){
          return true
        }
        if(steps.step == ProcessStep.EXTRACTION && steps.endPUID != "" && steps.endTimeStamp != null){
          return false
        }

      })
    }
  }

  showElement(type: string, processStep: string ,id: string){
    if(type=="PROCESS_STEP"){
      return this.processFlowProcessStepMap.has(this.selectedProcessFlow)
        && this.processFlowProcessStepMap.get(this.selectedProcessFlow).includes(id);
    }else if(type=="ACTION"){
      return this.mapOfProcessStepAndAction.has(processStep)
        && this.mapOfProcessStepAndAction.get(processStep).includes(id);
    }else if(type=="INPUT"){
      return this.processFlowInputMap.has(this.selectedProcessFlow)
        && this.processFlowInputMap.get(this.selectedProcessFlow).includes(id);
    }
    return false;
  }

  resetPlateIDs(multiUpdatePlateType){
    if(PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType){
      this.enteredPlateId = "";
    }else if(PlateIdTypes.LYSIS == multiUpdatePlateType){
      this.enteredLysisPlateId = "";
    }else if(PlateIdTypes.DNA == multiUpdatePlateType){
      this.enteredDnaPlateId = "";
    }else if(PlateIdTypes.MAGMIX == multiUpdatePlateType){
      this.enteredMagMixPlateId = "";
    }
  }

  checkPlate(multiUpdatePlateType: string = PlateIdTypes.LAST_UPDATED_PLATEID, firstMatchCondition: boolean = true){
    if(!firstMatchCondition){
      return this.checkPlateExists(multiUpdatePlateType);
    }
    let plateIDToBeChecked: string;
    if(PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredPlateId;
    }else if(PlateIdTypes.LYSIS == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredLysisPlateId;
    }else if(PlateIdTypes.DNA == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredDnaPlateId;
    }else if(PlateIdTypes.MAGMIX == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredMagMixPlateId;
    }

    if(plateIDToBeChecked && this.multiUpdatePlateList && this.multiUpdatePlateList.includes(plateIDToBeChecked)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }
    if(plateIDToBeChecked && this.multiUpdatePlateList && this.multiUpdatePlateList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }
    if(plateIDToBeChecked.trim()=="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId,plateIDToBeChecked,multiUpdatePlateType).subscribe({
      next:(result)=>{
        this.fetchedPlate = result;

        if(this.fetchedPlate.storagePlate && this.fetchedPlate.status !== PlateStatus.STORAGE_PLATE){
          this.multiPlateRestoreId.push(this.fetchedPlate.lastUpdatedPlateID)
        }

        if(!this.fetchedPlate.sampleType && this.processFlowNameProcessFlowMap.has(this.fetchedPlate.processFlowName)){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }
        var processFlowConfig : ProcessFlow = this.processFlowNameProcessFlowMap.get(this.fetchedPlate.processFlowName)
        if(!processFlowConfig){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }

        if((PlateStatus.LYSIS_STARTED + "_" + ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow
          || PlateStatus.LYSIS_STARTED + "_" +ExtractionProcessFlows.LYSIS_EXT_HAIR == this.multiUpdateStatusAndProcessFlow
          || PlateStatus.EXTRACTION_STARTED + "_" + ExtractionProcessFlows.EXT_EARTAG_TLR == this.multiUpdateStatusAndProcessFlow)
            && processFlowConfig.qcScan && this.fetchedPlate.status != PlateStatus.QCSCAN_COMPLETED) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }

        let fetchedProcessFlow = this.selectPlateFlowFromProcessFlow(processFlowConfig)
        if(!fetchedProcessFlow){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }

        if(fetchedProcessFlow != this.selectedProcessFlow || processFlowConfig.detailedWorkflow != this.detailedWorkflow){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }

        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);

        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = undefined;
          return;
        }


        if(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR == this.multiUpdateStatusAndProcessFlow){
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-lysis-plateid');
          return;
        }

        if(this.multiUpdateStatusAndProcessFlow == Action.TRANSFER_LYSIS+ "_" + this.selectedProcessFlow){
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-magmix-plateid')
          return;
        }

        if(this.multiUpdateStatusAndProcessFlow == Action.PREPARE_OKTOPURE+ "_" + this.selectedProcessFlow){
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-dna-plateid')
          return;
        }

        this.multiUpdatePlateList.unshift(plateIDToBeChecked);
        this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
        if("popUpWithDifferentMachine" == this.selectedPopUpString){
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.lastUpdatedPlateID = plateIDToBeChecked;
          plateUpdateInfo.plateID = plateIDToBeChecked;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler;

          if(`${PlateStatus.EXTRACTION_STARTED}_${ExtractionProcessFlows.LYSIS_EXT_HAIR}` == this.multiUpdateStatusAndProcessFlow){
            plateUpdateInfo.plateID = this.fetchedPlate.plateID
            plateUpdateInfo.addFirstAction = {
              "name":Action.TRANSFER_LYSIS,
              "runTime": this.mapOfActionRuntime.get(Action.TRANSFER_LYSIS),
              "liquidHandler": this.multiLiquidHandler
            }
          }
          /*
            lysisPlateID & dnaPlateID is currently set to the plateID for time being.
            This would change when the log file upload is implemented for the Transfer Lysis and Prepare OKTOpure.
            Transfer Lysis Log file would update the lysis plate id and
            Prepare OKTOpure Log file would update the dna plate id.

            In the future we would remove or modify this code.
          */

          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)

        }
        else if(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.lastUpdatedPlateID = plateIDToBeChecked;
          plateUpdateInfo.plateID = plateIDToBeChecked;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler;
          plateUpdateInfo.chemicals = this.multiPlateStepsMap.get(ProcessStep.LYSIS).chemicals;
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
        }

        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = undefined;
        this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
      },
      error:(_error)=>{
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + plateIDToBeChecked
        })
        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = undefined;
      }
    })
  }

  checkPlateExists(plateIDType: string){
    let plateIDToBeChecked: string;
    if(PlateIdTypes.LAST_UPDATED_PLATEID == plateIDType){
      plateIDToBeChecked = this.enteredPlateId;
    }else if(PlateIdTypes.LYSIS == plateIDType){
      plateIDToBeChecked = this.enteredLysisPlateId;
    }else if(PlateIdTypes.DNA == plateIDType){
      plateIDToBeChecked = this.enteredDnaPlateId;
    }else if(PlateIdTypes.MAGMIX == plateIDType){
      plateIDToBeChecked = this.enteredMagMixPlateId
    }

    if(plateIDToBeChecked.trim()=="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }

    if(plateIDToBeChecked && (this.multiUpdateLysisPlateList || this.multiUpdatePlateList || this.multiUpdateDnaPlateList || this.multiUpdateMagMixPlateList) &&  (this.multiUpdatePlateList.includes(plateIDToBeChecked) || this.multiUpdateLysisPlateList.includes(plateIDToBeChecked) || this.multiUpdateDnaPlateList.includes(plateIDToBeChecked) || this.multiUpdateMagMixPlateList.includes(plateIDToBeChecked))){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(plateIDType);
      plateIDToBeChecked = undefined;
      return;
    }

    this.platePreparationService.fetchPlate(plateIDToBeChecked,this.selectedLabId).subscribe({
      next:(_result)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: plateIDType+' Plate Already Exists!', detail: "Please scan a new "+plateIDType+" plateId" });
        if(PlateIdTypes.LAST_UPDATED_PLATEID == plateIDType){
          this.enteredPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
        }else if(PlateIdTypes.LYSIS == plateIDType){
          this.enteredLysisPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-lysis-plateid');
        }else if(PlateIdTypes.DNA == plateIDType){
          this.enteredDnaPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-dna-plateid');
        }else if(PlateIdTypes.MAGMIX == plateIDType){
          this.enteredMagMixPlateId = ""
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-magmix-plateid');
        }

      },
      error:(_error)=>{
        if(PlateIdTypes.LYSIS == plateIDType){
          this.multiUpdateLysisPlateList.unshift(plateIDToBeChecked)
        }else if(PlateIdTypes.DNA == plateIDType){
          this.multiUpdateDnaPlateList.unshift(plateIDToBeChecked)
        }else if(PlateIdTypes.MAGMIX == plateIDType){
          this.multiUpdateMagMixPlateList.unshift(plateIDToBeChecked)
        }


        if(PlateStatus.LYSIS_COMPLETED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR == this.multiUpdateStatusAndProcessFlow){
          this.multiUpdatePlateList.unshift(this.enteredPlateId);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.enteredPlateId;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.lysisPlateID = this.enteredLysisPlateId;
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.enteredPlateId = "";
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
          this.enteredLysisPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }

        if(PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR == this.multiUpdateStatusAndProcessFlow){
          this.multiUpdatePlateList.unshift(this.enteredLysisPlateId);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.lysisPlateID = this.enteredLysisPlateId;
          plateUpdateInfo.dnaPlateID = this.enteredDnaPlateId;
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.enteredPlateId = "";
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
          this.enteredLysisPlateId = "";
          this.enteredDnaPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }

        if(Action.TRANSFER_LYSIS+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
          this.multiUpdatePlateList.unshift(this.enteredPlateId);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.magMixPlateID = this.enteredMagMixPlateId;
          plateUpdateInfo.lysisPlateID = this.enteredLysisPlateId;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.enteredPlateId = "";
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
          this.enteredLysisPlateId = "";
          this.enteredMagMixPlateId = ""
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }

        if(Action.PREPARE_OKTOPURE+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
          this.multiUpdatePlateList.unshift(this.enteredPlateId);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.magMixPlateID = this.enteredMagMixPlateId;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.dnaPlateID = this.enteredDnaPlateId;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.enteredPlateId = "";
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
          this.enteredDnaPlateId = "";
          this.enteredMagMixPlateId = ""
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }
        if(`${Action.PREPARE_OKTOPURE}_${ExtractionProcessFlows.LYSIS_EXT_HAIR}` == this.multiUpdateStatusAndProcessFlow){
          this.multiUpdatePlateList.unshift(this.enteredPlateId);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.magMixPlateID = this.enteredMagMixPlateId;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.dnaPlateID = this.enteredDnaPlateId;
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.enteredPlateId = "";
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
          this.enteredDnaPlateId = "";
          this.enteredMagMixPlateId = ""
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }
      }
    })
  }

  checkMachineBarcode(focusOnSource: boolean = false, focusOnLysis: boolean = false, focusOnDna: boolean = false){
    if(this.multiLiquidHandler.trim() == ""){
      return;
    }

    if(!this.machinesBarcodeMap.has(this.multiLiquidHandler)){
      this._messagesService.addErrorMessage({
        severity:"error", summary:"Machine not found!",
        detail: "Machine with barcode "+this.multiLiquidHandler+" not found. Please check the barcode and scan again."
      })
      this.multiLiquidHandler = "";
      return;
    }

    if(focusOnSource){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-plateid");
      return;
    }
    else if(focusOnLysis){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-lysis-plateid");
      return;
    }
    else if(focusOnDna){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-dna-plate-id")
      return;
    }

    this.findAndHighlightElement(this.selectedPopUpString+"-popup-chemical")
    return;
  }

  eligiblePlate(stage: any, stepName: any, actionName: any, actionPos: any): boolean {
    if((!this.multiPlateStepsMap || this.multiPlateStepsMap==null || this.multiPlateStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiPlateStepsMap);
      default:
        return true;
    }
  }

  prepareProcessStepMapforMultiPlateUpdate(selectedPlate: Plate) {
    this.multiPlateStepsMap = new Map();
    if(!selectedPlate.processSteps || selectedPlate.processSteps==null)
      return;
    selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiPlateStepsMap.set(step.step, step);
    });
    this.multiPlateStepsMapList.push(this.multiPlateStepsMap);
  }

  deleteValue(index){
    this.multiUpdatePlateList.splice(index,1);
    this.multiUpdateLysisPlateList.splice(index,1);
    this.multiUpdateMagMixPlateList.splice(index,1)
    this.multiUpdateDnaPlateList.splice(index,1);
    this.multiUpdatePlateListSave.splice(index,1);
    this.multiPlateStepsMapList.splice(index,1);
    this.multiUpdatePlateInfoList.splice(index,1)
    this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  updateMultiPlates(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch(this.multiStage){
      case ProcessStepStage.start:
        this.updateStartProcessForMultiplePlates()
        break;
      case ProcessStepStage.end:
        this.updateEndProcessForMultiplePlates();
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessForMultiplePlates();
        break;
    }
  }

  getMultiUpdateDto(){
    let multiPlateUpdate : MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.action = this.multiActionName;
    multiPlateUpdate.plateids = this.multiUpdatePlateListSave;
    multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList;
    multiPlateUpdate.step = this.multiStepName;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.status = this.qcNanoDrop && PlateStatus.EXTRACTION_COMPLETED == this.multiUpdateStatus? PlateStatus.EXTRACTION_QC : this.multiUpdateStatus;
    multiPlateUpdate.actionRunTime = this.mapOfActionRuntime.get(this.multiActionName);
    if(this.multiCompleteProcessStep){
      multiPlateUpdate.completeProcessStep = this.multiCompleteProcessStep
      multiPlateUpdate.status = this.multiCompleteProcessStepStatus
    }
    multiPlateUpdate.chemicals = [
      {
        "chemical":this.mapOfStatusProcessFlowAndHeaders.get(this.multiUpdateStatusAndProcessFlow)[2],
        "lots": this.multiChemicalLotList
      }
    ]
    multiPlateUpdate.machineUpdateInfoDict = this.multiMachineUpdateInfoDict
    multiPlateUpdate.processFlow = this.selectedProcessFlow;
    multiPlateUpdate.qcNanodrop = this.qcNanoDrop
    return multiPlateUpdate;
  }

  updateStartProcessForMultiplePlates(){

    let multiUpdateDto = this.getMultiUpdateDto();

    if([
        PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR,
        PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR,
        PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG
      ].includes(this.multiUpdateStatusAndProcessFlow)){
      multiUpdateDto.chemicals = [
        {
          "chemical":this.mapOfStatusProcessFlowAndHeaders.get(this.multiUpdateStatusAndProcessFlow)[2],
          "lots": this.multiChemicalLotList
        }
      ]
    }
    if(`${PlateStatus.EXTRACTION_STARTED}_${ExtractionProcessFlows.LYSIS_EXT_HAIR}` == this.multiUpdateStatusAndProcessFlow){
      if(
        this.multiChemicalLotAMPList.length === 0 ||
        this.multiChemicalLotTN1List.length === 0 ||
        this.multiChemicalLotTN2List.length === 0 ||
        this.multiChemicalLotBN1List.length === 0
      ){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'One or more lots empty',
          detail: "Please fill all the Lot details to continue."
        });
        return
      }
      multiUpdateDto.plateUpdateInfoList.forEach( plateUpdate => {
        plateUpdate.chemicals = [
          {
            "chemical": "AMP",
            "lots": this.multiChemicalLotAMPList
          },
          {
            "chemical": "TN2",
            "lots": this.multiChemicalLotTN2List
          },
          {
            "chemical": "TN1",
            "lots": this.multiChemicalLotTN1List
          },
          {
            "chemical": "BN1",
            "lots": this.multiChemicalLotBN1List
          }
        ]
      }
    )
    }
    if(this.multiPlateRestoreId.length > 0){
      this.restorePlatesFromStorage(this.multiPlateRestoreId, () => {
        this.callBackUpdateStartProcessForMultiplePlates(multiUpdateDto)
      })
      return
    }
    this.callBackUpdateStartProcessForMultiplePlates(multiUpdateDto)
  }

  callBackUpdateStartProcessForMultiplePlates(multiUpdateDto){
    this.blocked = true
    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this.blocked = false
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.detailedWorkflow = true;

        if(this.multiUpdateStatusAndProcessFlow == PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_HAIR){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_56C, 2, ProcessStep.LYSIS, Action.INCUBATE_56C, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.EXT_EARTAG_TLR){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_65C, 2, ProcessStep.EXTRACTION, Action.INCUBATE_65C, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.LYSIS_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
          setTimeout(() => {
            this.multiSpinRequired = true
            this.multiSpinCheckboxValue = false
            this.savePlateStatus(Action.INCUBATE_56C_1H, 2, ProcessStep.LYSIS, Action.INCUBATE_56C_1H, 0)
          }, 1000);
        }
        else if(this.multiUpdateStatusAndProcessFlow == PlateStatus.EXTRACTION_STARTED+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
          setTimeout(() => {
            this.savePlateStatus(Action.INCUBATE_56C_R, 2, ProcessStep.EXTRACTION, Action.INCUBATE_56C_R, 0)
          }, 1000);
        }
        if([PlateStatus.START_PREPCR, PlateStatus.RECOMBINING_STARTED, PlateStatus.PRECIPITATION_STARTED, PlateStatus.RESUSPENDING_STARTED].includes(multiUpdateDto.status))
          this.updateMachine(multiUpdateDto.liquidHandler, multiUpdateDto.status, this.multiUpdateSelectedWorkFlow);
      },
      error:(error) =>{
        this.blocked = false
        if(this.multiStepName==ProcessStep.SAFE_STOPPING)
          this.multiUpdateStatus = PlateStatus.STORED;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  updateEndProcessForMultiplePlates(){
    if(this.multiPlateRestoreId.length > 0){
      this.restorePlatesFromStorage(this.multiPlateRestoreId,() => {
        this.callBackUpdateEndProcessForMultiplePlates()
      })
      return
    }
    this.callBackUpdateEndProcessForMultiplePlates()
  }

  callBackUpdateEndProcessForMultiplePlates(){
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true
    this.platePreparationService.updateEndProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this.blocked = false
        if(this.multiUpdateStatus == PlateStatus.EXTRACTION_COMPLETED){
          this.prepareMultiSampleDataList(multiUpdateDto,() => this.performProcessUpdateForWeatherby())
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.detailedWorkflow = true;
      },
      error:(error) =>{
        this.blocked = false
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }


  prepareSampleDataList<P extends string | Sample>(dataList : P[], mapperFunction : (p : P) => SampleData){
    dataList.forEach(
      data => {
        let sampleData = mapperFunction(data)
        this.weatherbySampleDataList.push(sampleData)
      }
    )
  }

  prepareMultiSampleDataList(multiUpdateDto:MultiPlateUpdate,callBack : () => void){
    let plateIds = multiUpdateDto.plateids
    let body = {
      "plateIDs" : plateIds
    }
    this.platePreparationService.fetchPlateWithSampleId(this.selectedLabId,body).subscribe({
      next:result => {
        let platesWithSample = result

        let sampleIds = platesWithSample.map(plateWithSample => plateWithSample.samples)
        .reduce((ids,currentSampleIds) => ids.concat(currentSampleIds),[])

        this.prepareSampleDataList<any>(sampleIds,sample => {
          return {
            sampleId : sample._id,
            description : "",
            stageGate : 3,
            status : ProcessUpdateStage.STAGE_GATE
          }
        })
        callBack()
      },
      error:error => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Error occurred while sending process update to weatherby.Error: ${error} `
        })
        this.weatherbySampleDataList = []
      }
    })
  }

  performProcessUpdateForWeatherby(){
    let weatherByProcessUpdateDto : ProcessUpdateDTO = {
      data :  this.weatherbySampleDataList,
      labId : this.selectedLabId
    }
    this.announcementService.weatherbyProcessUpdate(weatherByProcessUpdateDto,this.isProcessUpdateProxied).subscribe({
      next:_result => {
        this.weatherbySampleDataList = []
      },
      error:error => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Error occurred while sending process update to weatherby.Error: ${error} `
        })
        this.weatherbySampleDataList = []
      }
    })
  }

  addTransferLysisLots(){
      if(this.multiChemicalLotBN1 == ""){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Lot BN1 is empty',
          detail: "Please enter a valid Lot value"
        });
        return
      }
      else if(this.multiChemicalLotTN1 == ""){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Lot TN1 is empty',
          detail: "Please enter a valid Lot value"
        });
        return
      }
      else if(this.multiChemicalLotTN2 == ""){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Lot is empty',
          detail: "Please enter a valid Lot value"
        });
        return
      }
      else if(this.multiChemicalLotAMP == ""){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Lot is empty',
          detail: "Please enter a valid Lot value"
        });
        return
      }

      this.multiChemicalLotList.push(this.multiChemicalLot)
      this.multiChemicalLotBN1 = ""
      this.multiChemicalLotTN1 = "";
      this.multiChemicalLotTN2 = "";
      this.multiChemicalLotAMP = "";
  }


  addAMPLot(){
    if(this.multiChemicalLotAMP == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiChemicalLotAMPList.push(this.multiChemicalLotAMP);
    this.multiChemicalLotAMP = ''
  }

  addTN2Lot(){
    if(this.multiChemicalLotTN2 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiChemicalLotTN2List.push(this.multiChemicalLotTN2)
    this.multiChemicalLotTN2 = ''
  }

  addTN1Lot(){
    if(this.multiChemicalLotTN1 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiChemicalLotTN1List.push(this.multiChemicalLotTN1)
    this.multiChemicalLotTN1 = ''
  }

  addBN1Lot(){
    if(this.multiChemicalLotBN1 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiChemicalLotBN1List.push(this.multiChemicalLotBN1)
    this.multiChemicalLotBN1 = ''
  }

  addLot(){
    if(this.multiChemicalLot == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiChemicalLotList.push(this.multiChemicalLot)
    this.multiChemicalLot = ""
    }


  updateStartActionProcessForMultiplePlates(){
    let multiUpdateDto = this.getMultiUpdateDto();
    if(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
      multiUpdateDto.plateUpdateInfoList.forEach( plateUpdate => {
          plateUpdate.chemicals.forEach( val => {
            if(val.chemical == this.mapOfStatusProcessFlowAndHeaders.get(this.multiUpdateStatusAndProcessFlow)[2]){
              val.lots.push(this.multiChemicalLot)
            }
          })
        }
      )
    }
    if(Action.TRANSFER_LYSIS+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
      if(
        this.multiChemicalLotAMPList.length === 0 ||
        this.multiChemicalLotTN1List.length === 0 ||
        this.multiChemicalLotTN2List.length === 0 ||
        this.multiChemicalLotBN1List.length === 0
      ){
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'One or more lots empty',
          detail: "Please fill all the Lot details to continue."
        });
        return
      }
      multiUpdateDto.plateUpdateInfoList.forEach( plateUpdate => {
        plateUpdate.chemicals = [
          {
            "chemical": "AMP",
            "lots": this.multiChemicalLotAMPList
          },
          {
            "chemical": "TN2",
            "lots": this.multiChemicalLotTN2List
          },
          {
            "chemical": "TN1",
            "lots": this.multiChemicalLotTN1List
          },
          {
            "chemical": "BN1",
            "lots": this.multiChemicalLotBN1List
          }
        ]
      }
    )
    }
    if(this.multiPlateRestoreId.length > 0){
      this.restorePlatesFromStorage(this.multiPlateRestoreId, () => {
        this.callBackStartActionForMultiplePlates(multiUpdateDto)
      })
      return
    }
    this.callBackStartActionForMultiplePlates(multiUpdateDto)
  }

  callBackStartActionForMultiplePlates(multiUpdateDto:any){
    this.blocked = true
    this.platePreparationService.updateStartActionProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this.blocked = false
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        if(this.multiCompleteProcessStep){
          this.updateMultiPlateUpdateProcessStep(this.multiStepName,1,this.multiActionName)
          this.prepareMultiSampleDataList(multiUpdateDto, () => this.performProcessUpdateForWeatherby())
        }
        this.closeMultiUpdatePopup();
        this.detailedWorkflow = true;
        if(Action.ADD_CHEMICAL_MIX+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG == this.multiUpdateStatusAndProcessFlow){
          setTimeout(() => {
            this.selectedPlateStepsMap.get(ProcessStep.LYSIS).actionMap.set(
              Action.ADD_CHEMICAL_MIX, new StepAction()
            )
            this.savePlateStatus(Action.INCUBATE_56C_2H, 2, ProcessStep.LYSIS, Action.INCUBATE_56C_2H, 4)
          }, 1000);
        }else if(this.multiUpdateStatusAndProcessFlow == Action.STOP_INCUBATION_56C_ON+"_"+ExtractionProcessFlows.LYSIS_EXT_EARTAG){
          setTimeout(() => {
            this.savePlateStatus(Action.ADD_CHEMICAL_MIX, 2, ProcessStep.LYSIS, Action.ADD_CHEMICAL_MIX, 0)
          }, 1000);
        }
      },
      error:(error) =>{
        this.blocked = false
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  updateLastUpdatedPlates(){
    this.lastUpdatedPlates1 = [];
    this.lastUpdatedPlates2 = [];
    this.lastUpdatedPlates3 = [];
    this.chemicalsPlateids = [];
    for(var i=0;i<30;i++){
      let updatedPlate = { plateId : this.multiUpdatePlateList.length>i ? this.multiUpdatePlateList[i] : '' }
      if(i<10){
        this.lastUpdatedPlates1.push(updatedPlate)
      }else if(i<20){
        this.lastUpdatedPlates2.push(updatedPlate)
      }else{
        this.lastUpdatedPlates3.push(updatedPlate)
      }

      if(this.multiUpdatePlateList.length>i){
        this.chemicalsPlateids.push(this.multiUpdatePlateListSave[i]);
      }
    }
  }

  closeMultiUpdatePopup(performFetchCalls: boolean = true) {
    this.popUpWithDifferentMachine = false;
    this.popUpWithMachine = false;
    this.popUpWithMachineAndChemicals = false;
    this.popUpWithMachineAndChemicalsClosable = true;
    this.multiUpdatePopUp = false;
    this.multiCompleteProcessStep = false
    this.multiCompleteProcessStepStatus = ''
    this.multiPlateIdRequired = [false,false];
    this.multiLysisPlateIdRequired = [false,false];
    this.multiDnaPlateIdRequired = [false,false];
    this.multiMagMixPlateIdRequired= [false, false]

    this.enteredPlateId = "";
    this.enteredLysisPlateId = "";
    this.enteredDnaPlateId = "";
    this.enteredMagMixPlateId = "";
    this.multiLiquidHandler = "";
    this.multiChemicalLot = "";

    this.multiUpdatePlateList = [];
    this.multiUpdateLysisPlateList = [];
    this.multiUpdateMagMixPlateList = [];
    this.multiUpdateDnaPlateList = [];
    this.multiUpdatePlateListSave = [];
    this.multiUpdatePlateInfoList = [];
    this.multiMachineUpdateInfoDict = new Map();
    this.multiPlateStepsMap.clear();
    this.multiPlateStepsMapList = [];
    this.multiChemicalLotList = []
    this.multiChemicalLot = ""
    this.multiChemicalLotBN1 = ""
    this.multiChemicalLotAMP = ""
    this.multiChemicalLotTN1 = ""
    this.multiChemicalLotTN2 = ""
    this.multiChemicalLotAMPList = []
    this.multiChemicalLotBN1List = []
    this.multiChemicalLotTN1List = []
    this.multiChemicalLotTN2List = []
    this.nanoDropPass = false
    this.multiUpdateButtonStyleClass = "";
    if(performFetchCalls){
      this.searchForPlateAction(this.selectedPlate.plateID)
      this.onApplyFilter();
    }
  }

  updateMultiPlateUpdateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler=""){
    if(this.multiUpdateProcessStepsMap.has(step)){
      var existingStep = this.multiUpdateProcessStepsMap.get(step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          var existingAction = existingStep.actionMap.get(actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction)
        }
      }
    }else{
      var newStep = new Step();
      newStep.step = step;
      newStep.action = [];
      newStep.actionMap = new Map();
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        newStep.endTimeStamp = new Date();
        newStep.endPUID = this.puid;
      }else{
        var newAction = new StepAction();
        newAction.action = actionName;
        newAction.actionPUID = this.puid;
        newAction.actionStartTime = new Date();
        newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
        newStep.actionMap.set(actionName, newAction);
        newStep.action.push(newAction);
      }
      this.multiUpdateProcessStepsMap.set(step, newStep)
    }
  }

  updateMachine(barcode, status, workFlow){
    if(barcode != '' || barcode == null){
      let selectedMachine = this.machinesBarcodeMap.get(barcode);
      if(selectedMachine !== undefined){
        selectedMachine.latestProcessStep = this.machineProcessStepStatusMap.get(status);
        selectedMachine.latestProcessStepTimeStamp = new Date();
        selectedMachine.latestWorkFlow = workFlow;
        this.blocked = false;
        this.masterDataService.updateConfig(selectedMachine.lab, selectedMachine, "machine").subscribe({
          next:results => {
            this.blocked = false;
            if (!results) {
              return;
            }
            this.machinesList[this.machinesList.indexOf(selectedMachine)] = results.data
            this.machinesBarcodeMap.set(barcode,results.data);
          },
          error:_error => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Error in updating Machine',
              detail: "Error in updating machine status."
            });
          }
        });
      }
      else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Machine Does Not Exists',
          detail: "Machine with the given barcode does not exist."
        });
      }
    }
  }

  getProcessStepLiquidHandler(stepName){
    return this.selectedPlateStepsMap.get(stepName) ? this.selectedPlateStepsMap.get(stepName).liquidHandler : "";
  }

  disableInputFields(){
    return this.detailedWorkflow;
  }

  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  showQcPassPopUp(){
    this.nanoDropPass = true
    this.enteredPlateId = ""
    this.multiUpdatePlateInfoList = []
    this.multiUpdatePlateListSave = []
  }

  checkNullAndUndefined(variable: any){
    return variable!=null && variable!=undefined
  }

  checkPlateForQC(multiUpdatePlateType:string = PlateIdTypes.LAST_UPDATED_PLATEID){
    let plateIDToBeChecked: string;
    if(PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredPlateId.trim()
    }

    if(this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.includes(plateIDToBeChecked)){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.length > 20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && plateIDToBeChecked.trim() == "") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    this.blocked = true
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId,plateIDToBeChecked,multiUpdatePlateType).subscribe({
      next:result => {
        this.blocked = false
        this.fetchedPlate = result
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);

        let notEligible = this.eligiblePlate(0, ProcessStep.NANODROP_PASS,Action.QC_CHECK , 0);
        if (notEligible) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = "";
          return
        }

        if(this.nanoDropFail){
          this.populateRedoTypeDropDown(this.fetchedPlate)
          this.qcNanoDropFailPlateSampleMap.set(this.fetchedPlate.lastUpdatedPlateID, this.fetchedPlate.samples)
          return;
        }

        let plateUpdateInfo = new PlateUpdateInfo()
        plateUpdateInfo.plateID = this.fetchedPlate.plateID
        plateUpdateInfo.lysisPlateID = this.fetchedPlate.lysisPlateID
        plateUpdateInfo.dnaPlateID = this.fetchedPlate.dnaPlateID
        plateUpdateInfo.lastUpdatedPlateID = this.fetchedPlate.lastUpdatedPlateID

        this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
        this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID)


        this.resetPlateIDs(multiUpdatePlateType)
        plateIDToBeChecked = undefined
        this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow
      },
      error:_error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + plateIDToBeChecked
        })
        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = "";
      }
    })

  }

  populateRedoTypeDropDown(plate:Plate){
    let selectedWorkFlow = this.workFlowData.find(workFlow => workFlow.workFlowName == plate.workFlow)
    if(!selectedWorkFlow){
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No workflow found for plate'});
      this.resetPlateIDs(PlateIdTypes.LAST_UPDATED_PLATEID);
      return;
    }

    this.blocked = true
    this.platePreparationService.getProcessFlow(plate.processFlowName,this.selectedLabId).subscribe({
      next : (processFlowResult) => {
        this.blocked = false
        let processFlow: ProcessFlow
        if(processFlowResult.data){
          processFlow = processFlowResult.data

          if(processFlow.okTOpureHair){
            this.qcFailRedoList = this.hairRedoList;
          }else if(processFlow.okTOpureEartag){
            this.qcFailRedoList = this.eartagRedoList;
          }else{
            this.qcFailRedoList = [];
          }
        }

        if(plate.sampleType=="DNA" && plate.processSteps.length > 1){
          if(plate.workFlow=="ICBF"){
            this.qcFailRedoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": plate.processSteps[1].step, status: PlateStatus.RECEPTION_COMPLETED}});
          }else{
            this.qcFailRedoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": plate.processSteps[1].step, status: PlateStatus.RECEIVED}});
          }
        }
        this.popUpRedoSelector.show();
        this.popUpRedoSelector.focus();
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'No process flow found',
          detail: 'Either no configured process flow in MDM or no sample type in plate.'
        });
      }
   })
  }

  addPlateForQCFail(){
    if(this.enteredPlateId.trim() == ""){
      return;
    }

    if(this.selectedRedoReason.redoLabel.length === 0){
      this.popUpRedoSelector.focus()
      this.popUpRedoSelector.show()
      return
    }

    let plateUpdateInfo = new PlateUpdateInfo()
    plateUpdateInfo.plateID = this.fetchedPlate.plateID
    plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId
    plateUpdateInfo.redoLabel = this.selectedRedoReason.redoLabel
    plateUpdateInfo.redo = this.selectedRedoReason.redo
    plateUpdateInfo.status = this.selectedRedoReason.status
    plateUpdateInfo.sampleType = this.selectedRedoReason.sampleType
    plateUpdateInfo.stepName = this.selectedRedoReason.stepName
    this.multiUpdatePlateInfoList.unshift(plateUpdateInfo);
    this.multiUpdatePlateList.unshift(this.enteredPlateId)
    this.multiUpdatePlateListSave.unshift(this.fetchedPlate.lastUpdatedPlateID);
    this.resetPlateIDs(PlateIdTypes.LAST_UPDATED_PLATEID)
    this.qcFailRedoList = []
    this.selectedRedoReason = '';
    this.findAndHighlightElement('qcfail-plate-id')
  }

  deleteAmpLotValues(index:number){
    this.multiChemicalLotAMPList.splice(index,1)
  }

  deleteTN2LotValues(index:number){
    this.multiChemicalLotTN2List.splice(index,1)
  }

  deleteTN1LotValues(index:number){
    this.multiChemicalLotTN1List.splice(index,1)
  }

  deleteBN1LotValues(index:number){
    this.multiChemicalLotBN1List.splice(index,1)
  }

  hideDialog(reloadPlateData: boolean = false){
    if(reloadPlateData){
      this.searchForPlateAction(this.selectedPlate.lastUpdatedPlateID)
    }
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }
}
